<template>
  <div>
    <h2>{{ name }}</h2>

    <p>
      {{ date }} | {{ complimentaryTickets.used }} out of
      {{ complimentaryTickets.total }} complimentary member tickets used
    </p>

    <tickets-purchased :ticketsPurchased="ticketsPurchased"></tickets-purchased>
  </div>
</template>

<script>
import TicketsPurchased from "@/components/TicketsPurchased";

export default {
  name: "Event",
  components: {
    TicketsPurchased
  },
  props: ["name", "date", "complimentaryTickets", "ticketsPurchased"]
};
</script>

<style lang="scss" scoped>
p {
  font-size: 14px;
  color: #8a8a8a;
  letter-spacing: 0;
  line-height: 20px;
}
</style>
